import axios from "axios";
import { apiUrl, PORT } from "../../environment";
// import { getInfo } from "./Auth.header";
// import queryString from "query-string";

/**
* @description registration in db.
* @param {*} data
* @param {*} callback
*/

export const registration = (data, callback, dispatch) => {
    try {
        //   dispatch(loadingAction(true));
        return axios
            .post(`${apiUrl}${PORT}/user-service/create-provider`, data)
            .then((response) => {
                //   dispatch(loadingAction(false));
                // callback(response.data);
                return response;
            })
            .catch((error) => {
                //   dispatch(loadingAction(false));
                // callback(false);            
                return error
            });
    } catch (err) {
    }
};

/**
 * @description contactUs in db.
 * @param {*} data
 * @param {*} callback
 */

const ProviderService = {
    registration,
};

export default ProviderService;
